import { styled } from 'styled-components';

export enum ButtonVariant {
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
  Gradient = 'GRADIENT',
}

export interface ButtonProps {
  variant?: ButtonVariant;
  size?: 'small' | 'medium' | 'large';
}

export const Button = styled.button<ButtonProps>`
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;

  ${({ size = 'medium', theme }) => {
    switch (size) {
      case 'small':
        return `padding: ${theme.spacing.xs} ${theme.spacing.sm}; font-size: ${theme.typography.fontSizes.sm};`;
      case 'large':
        return `padding: ${theme.spacing.sm} ${theme.spacing.md}; font-size: ${theme.typography.fontSizes.lg};`;
      default:
        return `padding: ${theme.spacing.xs} ${theme.spacing.sm}; font-size: ${theme.typography.fontSizes.md};`;
    }
  }}

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: ${({ theme }) => theme.typography.fontSizes.sm};
  }

  ${({ variant = ButtonVariant.Primary, theme }) => {
    switch (variant) {
      case ButtonVariant.Secondary:
        return `
          background-color: ${theme.colors.white};
          color: ${theme.colors.primary};
          border: 1px solid ${theme.colors.primary};
          border-radius: ${theme.borderRadius.sm};
          &:hover {
            background-color: ${theme.colors.secondary};
          }
        `;
      case ButtonVariant.Gradient:
        return `
          background: ${theme.gradients.primary};
          color: white;
          border-radius: ${theme.borderRadius.sm};
          &:hover {
            transform: translateY(-2px);
            box-shadow: ${theme.shadows.md};
          }
        `;
      default:
        return `
          background-color: ${theme.colors.primary};
          color: white;
          border-radius: ${theme.borderRadius.sm};
          &:hover {
            background-color: ${theme.colors.primaryDark};
          }
        `;
    }
  }}
`;
